import { api } from "../config/api";
import { removePushSubscription } from "./pushDevice";

export const register = async (data) => {
  localStorage.clear();

  const payload = {
    Name: data.name,
    Email: data.email,
    Password: data.password,
    ConfirmPassword: data.confirmPassword,
    UserType: data.userType,
    Cpf: data.cpf || null,
    Cnpj: data.cnpj || null,
    Phone: data.phone || null,
  };
  const response = await api.post("/Auth/register", payload);

  if (response.data && response.data.id) {
    localStorage.setItem("userId", response.data.id);
    localStorage.setItem("userType", response.data.userType);

    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }
  }

  return response.data;
};

export const login = async (email, password) => {
  const response = await api.post("/Auth/login", {
    Email: email,
    Password: password,
  });

  const { token, id, userType } = response.data;

  localStorage.setItem("token", token);
  localStorage.setItem("userId", id);
  localStorage.setItem("userType", userType);

  return response.data;
};

export const refreshToken = async () => {
  // O cookie httpOnly viaja sozinho (withCredentials: true no api.js)
  const response = await api.post("/Auth/refresh-token");

  const { token, id, userType } = response.data;

  localStorage.setItem("token", token);
  localStorage.setItem("userId", id);
  localStorage.setItem("userType", userType);

  return response.data;
};

export const logout = async () => {
  try {
    // Este aparelho para de receber avisos da conta que está saindo
    await removePushSubscription();
    await api.post("/Auth/logout");
  } catch {
    // mesmo se falhar no servidor, limpa localmente
  } finally {
    localStorage.clear();
    sessionStorage.removeItem("push-synced");
    window.location.href = "/";
  }
};

export const getMe = async () => {
  const response = await api.get("/Users/me");
  return response.data;
};

export const getUserById = async (userId) => {
  const response = await api.get(`/Users/${userId}`);
  return response.data;
};

export const updateProfile = async (id, data) => {
  const payload = {
    name: data.name,
    nomeSocial: data.nomeSocial || null,
    phone: data.phone,

    // ENDEREÇO
    address: data.address || null,
    cep: data.cep?.replace(/\D/g, '') || null,
    logradouro: data.logradouro || null,
    numero: data.numero || null,
    complemento: data.complemento || null,
    bairro: data.bairro || null,
    cidade: data.cidade || null,
    estado: data.estado || null,

    // COORDENADAS
    lat: data.lat ?? null,
    lng: data.lng ?? null,

    cnpj: data.cnpj || null,
    avatarUrl: data.avatarUrl || null,
    gender: data.gender || null,
    searchRadius: data.searchRadius ?? 0,
    bio: data.bio || null,

    documentType: data.documentType || null,
    documentUrlFront: data.documentUrlFront || null,
    documentUrlBack: data.documentUrlBack || null,
    documentStatus: data.documentStatus || null,

    areas: data.areas || [],

    workExperiences: (data.workExperiences || []).map(
      ({ companyName, position, workMonth, workYear }) => ({
        companyName,
        position,
        workMonth,
        workYear,
      })
    ),
  };

  const response = await api.put(`/Users/${id}`, payload);

  return response.data;
};

export const updateAvatar = async (id, avatarUrl) => {
  const response = await api.put(`/Users/${id}/avatar`, { avatarUrl });
  return response.data;
};

export const corporateContracts = {
  getMine: async () => {
    const response = await api.get("/corporate-contracts/mine");
    return response.data;
  },
};

export const markTutorialSeen = async (id) => {
  const response = await api.patch(`/Users/${id}/tutorial-seen`);
  return response.data;
};

// ========================================
// RECUPERAÇÃO DE SENHA
// ========================================

export const forgotPassword = async (email) => {
  const response = await api.post("/Auth/forgot-password", {
    Email: email,
  });

  return response.data;
};

export const resetPassword = async (
  token,
  newPassword,
  confirmPassword
) => {
  const response = await api.post("/Auth/reset-password", {
    Token: token,
    NewPassword: newPassword,
    ConfirmPassword: confirmPassword,
  });

  return response.data;
};

export const validateResetToken = async (token) => {
  const response = await api.get(
    `/Auth/validate-reset-token?token=${encodeURIComponent(token)}`
  );

  return response.data.isValid;
};